import { useEffect } from "react";
import { useDispatch } from "react-redux";
import PropTypes from "prop-types";

const UpdateProductDetails = ({
    originalStoreCartItemIndex,
    indexOfItemAlreadyInStoreCart,
    modalAccessedFromStoreList,
    setFieldValue,
    storeCart,
    updateCurrentStoreCartItemIndex = () => {},
}) => {
    const dispatch = useDispatch();
    // From Store Page List (modalAccessedFromStoreList), if an item is already in the cart we want to update the
    // quantity to reflect what is in the cart.  This will change this modal/submit to
    // an update.  If the user changes the attributes selected then we are no longer updating this
    // product. Instead we are either adding a new (if not already in the cart) or
    // updating a different item in the cart. Because this value is not initially set,
    // we must manually set the Quantity to reflect what is already in the cart.

    useEffect(() => {
        if (storeCart && storeCart.length > 0) {
            const defaultIndexForStoreItem = modalAccessedFromStoreList
                ? -1
                : originalStoreCartItemIndex;

            dispatch(
                updateCurrentStoreCartItemIndex(
                    indexOfItemAlreadyInStoreCart !== -1
                        ? indexOfItemAlreadyInStoreCart
                        : defaultIndexForStoreItem,
                ),
            );

            setFieldValue(
                "Product_Quantity",
                indexOfItemAlreadyInStoreCart !== -1
                    ? storeCart[indexOfItemAlreadyInStoreCart].Product_Quantity
                    : 1,
            );
        }
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [
        indexOfItemAlreadyInStoreCart,
        modalAccessedFromStoreList,
        originalStoreCartItemIndex,
    ]);

    return null;
};

UpdateProductDetails.propTypes = {
    originalStoreCartItemIndex: PropTypes.number.isRequired,
    indexOfItemAlreadyInStoreCart: PropTypes.number.isRequired,
    modalAccessedFromStoreList: PropTypes.bool.isRequired,
    setFieldValue: PropTypes.func.isRequired,
    storeCart: PropTypes.arrayOf(
        PropTypes.shape({ Product_Quantity: PropTypes.number }),
    ).isRequired,
    updateCurrentStoreCartItemIndex: PropTypes.func.isRequired,
};

export default UpdateProductDetails;
